import { createContext, ReactElement, ReactNode, useCallback, useContext } from 'react'

import { EmberEventFn } from '../types/emberEventFn'

export interface RegisterPaymentOptions {
  accountId?: string
  id: string
  onBack?: Function
}

interface ContextState {
  invalidateBill: (billId: string) => void
}

const BillsEmberConnectionContext = createContext<ContextState | undefined>(undefined)

interface BillsEmberConnectionContextProps {
  children?: ReactNode
  onInvalidateBill: EmberEventFn
}

export const BillsEmberConnectionContextProvider = ({
  onInvalidateBill,
  children,
}: BillsEmberConnectionContextProps): ReactElement => {
  const invalidateBill = useCallback(
    (billId: string) => {
      onInvalidateBill({ detail: { props: { id: billId } } })
    },
    [onInvalidateBill],
  )

  return (
    <BillsEmberConnectionContext.Provider value={{ invalidateBill }}>{children}</BillsEmberConnectionContext.Provider>
  )
}

export const useBillsEmberConnection = () => {
  const context = useContext(BillsEmberConnectionContext)

  if (!context) {
    throw new Error('BillsEmberConnectionContextProvider is missing in the module!')
  }

  return context
}
